	document.addEventListener('DOMContentLoaded', function () {

		const screenWidth = window.screen.width;
		const winInnerHeight = window.innerHeight;

		const getDisplaySrc = (image) => {
			const { rawWidth, rawHeight, designWidth, filename, minWidth, defaultWidth } = image.dataset;
			const displayWidth = (designWidth > screenWidth) ? (minWidth > screenWidth ? minWidth : screenWidth) : designWidth?.trim();

			const widthPrefix = `_${defaultWidth || '10x'}.`;
			
			if (image instanceof HTMLImageElement) return filename.replace(widthPrefix, `_${displayWidth}x.`)

			let backgroundSrc = image.style.backgroundImage.match(/\/\/.*\)/g);

			if (Array.isArray(backgroundSrc) && backgroundSrc[0]) {
				return filename.replace(widthPrefix, `_${displayWidth}x.`);
			}

			return null;
		}
		window.asyncLoadImage = () => {
			/**全局调用异步加载图片
			第一屏禁止使用异步加载图片，防止爬虫抓取到失真图片
			由display：none切换的，需要手动触发该方法
			*/
			const unloadImages = Array.from(document.querySelectorAll('[data-img-loaded="false"],[data-background-loaded="false"]'));
			
			unloadImages.forEach(image => {
				if (image.clientHeight > 0) {
					const imageInfo = image.getBoundingClientRect();

					if (imageInfo.top < (winInnerHeight + 10)) {

						const isImgTag = image instanceof HTMLImageElement;

						const displaySrc = getDisplaySrc(image);

						if (!displaySrc) return;

						const newImage = new Image();
						newImage.src = displaySrc;

						newImage.onload = () => {
							if (isImgTag) {
								image.src = displaySrc;
								image.setAttribute('data-img-loaded', true);
							} else {
								image.style.backgroundImage = `url("${displaySrc}")`;
								image.setAttribute('data-background-loaded', true);
							}

							// image.removeAttribute('data-filename');
						}

					}
				}
			})
		}
		window.addEventListener('scroll', asyncLoadImage, false);
		window.addEventListener('resize', asyncLoadImage, false);
		asyncLoadImage();

	}, false)